import axios from 'axios';
import { apiUrl, authKey_local_storage_key } from "../helpers/common";
import { performAutoLogout } from "../helpers/SessionTimer";

const clientUrl = (uri) => {
  // 1. Pehle check karein ki 'uri' ke shuru mein slash hai ya nahi
  const cleanUri = uri.startsWith('/') ? uri.substring(1) : uri;

  // 2. Check karein ki 'apiUrl' ke end mein slash hai ya nahi
  const cleanBase = apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;

  // 3. Dono ko ek single slash se jodein aur END wala slash forcefully hata dein
  const finalUrl = `${cleanBase}/${cleanUri}`.replace(/\/$/, "");

  console.log("DEBUG: Final Constructed URL ->", finalUrl);
  return finalUrl;
};
;

const axiosInstance = axios.create();

let isHandlingSessionExpiry = false;

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;

    if (status === 401 && !isHandlingSessionExpiry) {
      isHandlingSessionExpiry = true;
      performAutoLogout();
    }

    return Promise.reject(error);
  },
);

const objectToFormData = (obj, form, namespace) => {
  const fd = form || new FormData();
  let formKey;
  const objectKeys = Object.keys(obj);

  objectKeys.forEach((property) => {
    if (namespace) {
      formKey = `${namespace}[${property}]`;
    } else {
      formKey = property;
    }

    const value = obj[property];

    if (Array.isArray(value)) {
      // value is an Array
      arrayToFormData(fd, formKey, value); // eslint-disable-line no-use-before-define
    } else if (typeof value === 'object' && !(value instanceof File)) {
      // value is a nested object
      objectToFormData(value, fd, formKey);
    } else {
      // value is a string or a File object
      fd.append(formKey, value);
    }
  });

  return fd;
};

const arrayToFormData = (fd, formKey, value) => {
  value.forEach((a) => {
    if (typeof a === 'object' && !(a instanceof File)) {
      // elements of array is nested object
      objectToFormData(value, fd, `${formKey}[]`);
    } else {
      // elements of array is string or File object
      fd.append(`${formKey}[]`, a);
    }
  });
};

const buildParam = (params, asJSON = true) => {
  if (asJSON) {
    return JSON.stringify(params);
  }
  return objectToFormData(params);
};

const getDefaultOptions = () => ({ method: 'GET', headers: {} });

function ajax(uri, options = {}) {
  let defaultOptions = getDefaultOptions();

  const token = localStorage.getItem(authKey_local_storage_key);

  defaultOptions = {
    ...defaultOptions,
    method: options.method || defaultOptions.method
  };

  if (token) {
    defaultOptions.headers['Authorization'] = `Bearer ${token}`;
  }

  if (options.data) {
    if (options.formData) {
      defaultOptions.data = buildParam(options.data, false);
    } else {
      defaultOptions.headers['Content-Type'] = 'application/json; charset=UTF-8';
      defaultOptions.data = buildParam(options.data);
    }
  }

  // if a file is attached
  if (options.attachment) {
    delete defaultOptions.headers['Content-Type'];
    defaultOptions.data = options.data;
  }

  // Handle response type
  if (options.responseType) {
    defaultOptions.responseType = options.responseType;
  }

  defaultOptions.url = clientUrl(uri);

  console.log("FINAL URL:", defaultOptions.url);
  console.log("RESPONSE TYPE:", defaultOptions.responseType);

  return axiosInstance(defaultOptions);
}

export default ajax;